// Subzone de dobândă pentru tabelul de produse (derivate din datele existente, fără câmp nou în DB)
// Regula: variabilă = interest_type 'variable'; fixă pe toată perioada = perioadă fixă >= FULL_PERIOD_YEARS;
// mixtă = fixă o perioadă, apoi variabilă.

export const FULL_PERIOD_YEARS = 25; // peste acest prag, dobânda fixă acoperă practic toată durata creditului

export const ZONES = [
  { key: 'variabila', label: 'Dobândă variabilă pe toată perioada creditului', color: 'border-l-sky-400' },
  { key: 'fixa', label: 'Dobândă fixă pe toată perioada creditului', color: 'border-l-emerald-400' },
  { key: 'mixta', label: 'Dobândă mixtă (fixă o perioadă, apoi variabilă)', color: 'border-l-amber-400' },
];

export const maxYears = (product = {}) => {
  const months = product.max_period_months;
  return months ? Math.round(months / 12) : 30;
};

export const getZone = (product = {}) => {
  if (product.interest_type === 'variable') return 'variabila';
  const years = Number(product.fixed_years) || 0;
  if (years <= 0) return 'variabila';
  return years >= Math.min(FULL_PERIOD_YEARS, maxYears(product)) ? 'fixa' : 'mixta';
};

// Ordine stabilă: nu depinde de câmpurile editabile, deci produsul nu se mută la salvare
export const stableSort = (products = []) =>
  [...products].sort((a, b) => {
    const ta = String(a.created_at || '');
    const tb = String(b.created_at || '');
    if (ta !== tb) return ta < tb ? -1 : 1;
    return String(a.id).localeCompare(String(b.id));
  });

export const groupByZone = (products = []) =>
  ZONES.map((zone) => ({ ...zone, products: stableSort(products.filter((p) => getZone(p) === zone.key)) }));
